module.exports = __webpack_public_path__ + "img/bp_lp_watage_bg.1c1a8ce4.jpg";